import { render } from "./EditPayCurrency.vue?vue&type=template&id=1396b2d1"
import script from "./EditPayCurrency.vue?vue&type=script&lang=js"
export * from "./EditPayCurrency.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__